import React from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import { ZenIcon, ZenText, ZenToast } from 'zen-core-elements';
import { useAppNavigation } from '../../types/@react-navigation/navigation';
import MobileScanner from './sellscreenProducts/mobileScanner';
import { Theme, ThemeConsumer } from '@rneui/themed';
import { shallowEqual } from 'react-redux';
import { getScreenPermission, useAppSelector } from '../../redux/hooks';

export const QuickActionButton = ({ icon, label, color, onPress, isWrite }: { icon: string, label: string, color: string, onPress?: () => void, isWrite: boolean }) => (
	<ThemeConsumer>
		{({ theme }) => {
			const styles = style(theme)
			return (
				<TouchableOpacity style={[styles.actionCard, { backgroundColor: color }]} disabled={!onPress} onPress={() => {
					isWrite ? onPress?.() : ZenToast({ message: "You don't have access!", type: "warning" })
				}}>
					<ZenIcon type='material-community' name={icon} size={28} color={theme?.light} />
					<ZenText content={label} style={styles.actionText} />
				</TouchableOpacity>
			)
		}}
	</ThemeConsumer>
);

const EmptyCart = ({ isWrite }: { isWrite: boolean }) => {
	const navigation = useAppNavigation()
	const { isRead: isOrderRead } = useAppSelector(getScreenPermission("OrdersStack"), shallowEqual);
	const { isWrite: isProductWrite } = useAppSelector(getScreenPermission("ProductStack"), shallowEqual);
	const { isWrite: isTaxWrite } = useAppSelector(getScreenPermission("TaxStack"), shallowEqual);

	return (
		<ThemeConsumer>
			{({ theme }) => {
				const styles = style(theme)
				return (
					<View style={styles.container}>

						<View style={styles.headerContainer}>
							<View style={styles.iconCircle}>
								<ZenIcon type='material-community' name="basket-outline" size={48} color="#CBD5E1" />
							</View>
							<ZenText content="Ready for Sale" style={styles.title} />
							<ZenText content="Select an item or use a quick action below." style={styles.subtitle} />
						</View>

						<View style={styles.gridContainer}>
							<MobileScanner
								ui={<QuickActionButton isWrite={true} icon="barcode-scan" label="Scan Item" color={theme?.blue600} />}
							/>

							<QuickActionButton isWrite={isOrderRead} icon="history" label="Last Order" color={theme?.tip} onPress={() => navigation?.navigate("OrdersStack")} />
							<QuickActionButton isWrite={isProductWrite} icon="plus-circle-outline" label="Add Product" color={theme?.addCharge} onPress={() => navigation?.navigate("ProductStack", { screen: "AddEditProduct" })} />
							<QuickActionButton isWrite={isTaxWrite} icon="gift-outline" label="Add Tax" color={theme?.tealGreen} onPress={() => navigation?.navigate("TaxStack", { screen: "AddEditTax" }, {})} />
						</View>
					</View>
				)
			}}
		</ThemeConsumer>
	);
};

const style = (theme: Theme) => StyleSheet.create({
	container: {
		flex: 1,
		justifyContent: 'center',
		alignItems: 'center',
		top: -25
	},
	headerContainer: {
		alignItems: 'center',
		marginBottom: 40,
	},
	iconCircle: {
		width: 100,
		height: 100,
		borderRadius: 50,
		backgroundColor: theme?.blue50,
		justifyContent: 'center',
		alignItems: 'center',
		marginBottom: 16,
	},
	title: {
		fontSize: theme?.headerFontSize,
		fontFamily: theme.bold,
		color: theme?.lightDark,
		marginBottom: 8,
	},
	subtitle: {
		fontSize: theme?.errorFontSize,
		fontFamily: theme.medium,
		color: theme?.draggerIcon,
	},
	gridContainer: {
		flexDirection: 'row',
		flexWrap: 'wrap',
		justifyContent: 'center',
		gap: 16,
		maxWidth: 400,
	},
	actionCard: {
		width: '45%',
		aspectRatio: 1.6,
		borderRadius: 16,
		padding: 16,
		justifyContent: 'space-between',

		shadowColor: '#000',
		shadowOffset: { width: 0, height: 4 },
		shadowOpacity: 0.1,
		shadowRadius: 12,
		elevation: 5,
	},
	actionText: {
		color: theme?.light,
		fontFamily: theme.medium,
		fontSize: theme?.smallHeaderFontSize,
	},
});

export default EmptyCart;